import { createReducer } from '@reduxjs/toolkit'
import { Actions_OrganizationInvitationCodes } from './Actions'
import { IStateOrganizationInvitationCodes } from './TReducer'

const initialState: IStateOrganizationInvitationCodes = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerOrganizationInvitationCodes = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_OrganizationInvitationCodes.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_OrganizationInvitationCodes.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_OrganizationInvitationCodes.store.saveCodes, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_OrganizationInvitationCodes.store.reset, () => {
      return initialState
    })
})

export default ReducerOrganizationInvitationCodes
